module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/publicnotes/publicnotes.component.css
// module id = ./src/app/components/publicnotes/publicnotes.component.css
// module chunks = main